module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_04-f75b4b5df150bc98185d5f3c16b5163f.png";